import { doesArrayHasLength, isDefined } from '../../../utils/isDefined';
import mapNumberToDisplay from '../../../utils/mapNumberToDisplay';

export function mapCellNumbers(data) {
  return data.sim_cards
    .map(simcard =>
      doesArrayHasLength(simcard?.cell_numbers)
        ? mapNumberToDisplay(simcard.cell_numbers[0].number)
        : null
    )
    .filter(number => isDefined(number));
}
